"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  min-width: 574px;\n  height: ", ";\n  background-color: ", ";\n  @media (max-width: 768px) {\n    display: none;\n  }\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    display: block;\n    height: ", ";\n    background-color: ", ";\n    width: ", ";\n    transition: width 1s ease-in-out;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ProgressTrack = _styledComponents.default.div(_templateObject(), function (_ref) {
  var height = _ref.height;
  return height || '5px';
}, function (_ref2) {
  var background = _ref2.background,
      theme = _ref2.theme;
  return background || theme.ui.backgroundLight;
}, function (_ref3) {
  var height = _ref3.height;
  return height || '5px';
}, function (_ref4) {
  var filledColor = _ref4.filledColor,
      theme = _ref4.theme;
  return filledColor || theme.brand.primary;
}, function (_ref5) {
  var len = _ref5.len,
      activeId = _ref5.activeId;
  return len ? "".concat(activeId * (100 / len), "%") : 0;
});

var LoadingBar = function LoadingBar(_ref6) {
  var activeId = _ref6.activeId,
      background = _ref6.background,
      height = _ref6.height,
      stagesLength = _ref6.stagesLength,
      otherProps = _objectWithoutProperties(_ref6, ["activeId", "background", "height", "stagesLength"]);

  var currentId = activeId;
  var len = stagesLength + 1;
  return _react.default.createElement(ProgressTrack, _extends({
    height: height,
    activeId: currentId,
    background: background,
    len: len
  }, otherProps));
};

LoadingBar.defaultProps = {
  activeId: 1,
  background: '',
  height: '7px',
  otherProps: {}
};
LoadingBar.propTypes = {
  activeId: _propTypes.number,
  background: _propTypes.string,
  otherProps: _propTypes.object,
  stagesLength: _propTypes.number,
  height: _propTypes.string
};
var _default = LoadingBar;
exports.default = _default;